module.exports = __webpack_public_path__ + "static/media/brahma.cc6a6380.jpg";